//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  //import { mapGetters } from 'vuex'
  import ChangeLang from './ChangeLang'
  import ChangeSys from './ChangeSys'
  import ftImg from '../assets/images/ft-main-logo.png'
  import dtImg from '../assets/images/DITO-logo.png'
  //import ChangeTheme from './ChangeTheme'
  import * as axios from "@/store/http";
    export default {
      name: "pcHeader",
      props: {
        showSidebarOpenBtn: {
          type: Boolean,
          default: false
        }
      },
      components:{
				ChangeLang,
				ChangeSys
      },
      data(){
        return{
          showmenu:true,
          userInfo:'系统管理员（HKADMIN）',
          circleUrl:require('../assets/images/contractTopRightUser.png'),
          headerDropData:[
            {title:this.$t('login.retreat'),iconClass:'el-icon-s-unfold',action:'loginOut'},
            {title:this.$t('login.switchingusers'),iconClass:'el-icon-user',action:'alertWindow'}
          ],

          // options: [{
          //   value: 'zh',
          //   label: '中文'
          // }, {
          //   value: 'en',
          //   label: 'English'
          // }, {
          //   value: 'pi',
          //   label: 'Pilipinas'
          // }
          //   ],
          // value: '',//语言选择下拉框当前语言文字描述
          theme:'',
          dialogFormVisible:false,//切换用户弹框,
          logsrc: "",

          // form: {
          //   name: '',
          //   region: '',
          // },
          // formLabelWidth: '120px'
        }
      },
      computed: {
        sidebarOpened() {
          return this.$store.state.sidebarOpened;
        },
        getImgUrl : function() {
           /**let sysflag = this.$route.query.sysflag;
           if(sysflag == 'ft'){
            return ftImg;
          }else{
            return dtImg;
          } **/        
        }
      },
      methods:{
        // 根据参数字符串调用对应同名方法
        handleCommand(funcname){
          eval("this."+funcname+"()");
          // if(funcname === 'loginOut'){
          //
          // }
        },
        // 切换语言
        // headChangeLang(value,label){
        //   this.changeLanguage(value) //调用公共切换语言方法
        //   this.value = label
        // },
        async loginOut() {
           this.$confirm(this.$t('common.logouttip'), this.$t('commonlist.tiptitle'), {
              confirmButtonText: this.$t('commonlist.confirm'),
              cancelButtonText: this.$t('commonlist.Cancel'),
              distinguishCancelAndClose: true
          }) .then(() => {
           let params = {
              path:process.env.API_LOGIN_ROOT
            };
            axios.post("login/loginout", params).then(({ data }) => {
              //门户系统登出
              if(data.code === "-3"){
                 console.log("=============logout");
                 this.$router.push({path: '/error',name:'error',params: {msg: this.$t('login.loginoutmsg')}});
              }
              if(data.code == '1'){
                this.$router.replace({ path: '/'});
              }
            });
          })
           
        },
        alertWindow() {
          this.dialogFormVisible = true
        },
        toggleSideBar(){
          let boolOpened = true
          if(this.sidebarOpened === true){
            boolOpened = false
          }
          this.$store.dispatch('setSidebarOpened',boolOpened)
        },
       async getCmsscpmisConfig() {//获取配置信息
      //保存定稿时间并返回附件信息
        let url = "menu/getCmsscpmisConfig";
        let params = {
          code:["companylogo"]
        };
         await this.axios
            .post(url, params)
            .then(({ data }) => {
              if ("1" === data.code) {
                //this.sysFlag=this.companylogo
                let companylogo=data.data.companylogo;
                if(companylogo=="1"){
                  this.logsrc = ftImg;
                }else{
                  this.logsrc = dtImg;
                }
              }
            })
            .catch(error => console.log(error));
    },

      },
      mounted(){
        // 初始化语言下拉框描述文字
        // for(var i=0; i<this.options.length; i++){
        //   if(this.options[i].value === this.$i18n.locale){
        //     this.value = this.options[i].label
        //     break
        //   }
        // }

      },
      created(){
        //门户过来则隐藏菜单信息
        let portalflag = this.$route.query.portalflag;
        let openflag = this.$route.query.openflag;
        if(portalflag == 'portal' || openflag == 'portal'){
            this.showmenu = false;
        }
        this.getCmsscpmisConfig();
      },
    }



// WEBPACK FOOTER //
// ./src/pccomponents/Header.vue